import { useEffect, useState, type Dispatch, type SetStateAction } from "react";

function templateStepFragment(stepId: string) {
  return `#template-step-${stepId}`;
}

export function useTemplateStepOpenState(
  stepId: string,
): [boolean, Dispatch<SetStateAction<boolean>>] {
  const [open, setOpen] = useState(
    () => window.location.hash === templateStepFragment(stepId),
  );

  useEffect(() => {
    if (!open || window.location.hash !== templateStepFragment(stepId)) return;

    const frame = window.requestAnimationFrame(() => {
      document.getElementById(`template-step-${stepId}`)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [open, stepId]);

  return [open, setOpen];
}
